export const isArray = (arr) => Array.isArray(arr)

export const isEmptyArray = (arr) => !!(Array.isArray(arr) && !arr?.length)

export const isNotEmptyArray = (arr) => !!(Array.isArray(arr) && arr?.length)
